import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import { useRef } from "react";
import { BiSolidDownload } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import { addRec, deleteRec, fetchListing } from "../../services";
import { filterActiveData, successToast } from "../../_helpers/utilities";
import moment from "moment";
import folder from "../../_assets/images/folder.png";

import { useFieldArray } from "react-hook-form";
import SearchableSelect from "../Master/searchableSelect";
import { messageText } from "../../store/actions";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import { useHistory } from "react-router-dom";
import { isArray } from "lodash";
import FilePreview from "../FIlePreview";

let GlobalAttachmentValid = !!+process.env.REACT_APP_ATTACHMENT_VALID

const UploadFile = ({
  formCtx = {},
  attachmentData,
  AttachmentFunc,
  AttachmentsDetailFunc,
  oldAttachments = false,
  zipid = false,
  moduleDetails = false,
  hideUpload = false,
  moduleName = "",
  MasterAttachmentVal = [],
  MasterSubAttachmentVal = [],
  removeOldFile = {},
  disabled = false,
  isEdit = false,
  ShowZipButton = true,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    control,
  } = formCtx;

  useFieldArray({
    control,
    name: "attachments",
  });

  const { fields: attachmentsDetailsFields, append: attachmentsDetailsAppend } =
    useFieldArray({
      control,
      name: "attachmentsDetails",
    });

  const attachmentsDetailArr = watch("attachmentsDetails");

  //console.log("attachmentsDetailArr", attachmentsDetailArr);
  const attachemntDetail = watch("attachmentsDetail");
  // console.log("attachemntDetail", attachemntDetail);
  const attachments = watch("attachments");

  const [localAttachments, setLocalAttachments] = useState([]);
  const { seedingData, message } = useSelector((state) => state.common);
  const [attachmentType, setAttachmentType] = useState([]);
  const [subAttachmentType, setSubAttachmentType] = useState([]);
  const [addFiles, setAddFiles] = useState(false);
  const [resetComp, setResetComp] = useState(false);
  const [deleteReset, setDeleteReset] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const history = useHistory();

  const dispatch = useDispatch();

  const uploadInputRef = useRef(null);
  let serialNumber = 1;
  useEffect(() => {
    if (firstTime) {
      setFirstTime(false);
      if (MasterAttachmentVal) {
        setAttachmentType(MasterAttachmentVal);
      }
      if (MasterSubAttachmentVal) {
        setSubAttachmentType(MasterSubAttachmentVal);
      }
    }
  }, [MasterAttachmentVal, MasterSubAttachmentVal, firstTime]);

  const AttachmentTypeList = async () => {
    if (
      isArray(MasterAttachmentVal) &&
      (MasterAttachmentVal?.length === 0 || MasterAttachmentVal?.length < 0)
    ) {
      let data = await fetchListing("/MasterAttachmentType/getalls");
      if (data?.status === 200) {
        var attachType = data?.data.map((obj) => ({ ...obj, name: obj.type }));
        setAttachmentType(filterActiveData(attachType));
      }
    }
  };

  const SubAttachmentTypeList = async () => {
    if (
      isArray(MasterSubAttachmentVal) &&
      (MasterSubAttachmentVal?.length === 0 ||
        MasterSubAttachmentVal?.length < 0)
    ) {
      let data = await fetchListing("/MasterSubAttachmentType/getalls");
      if (data?.status === 200) {
        var attachType = data?.data.map((obj) => ({ ...obj, name: obj.type }));
        setSubAttachmentType(filterActiveData(attachType));
      }
    }
  };

  useEffect(() => {
    AttachmentTypeList();
    SubAttachmentTypeList();
  }, []);
  // console.log("localattach", localAttachments)

  const handleRemoveAttachment = (index) => {
    document.getElementById("attachments").value = "";

    // console.log("uploadInputRef", uploadInputRef.current);

    let oldAttachments = localAttachments;
    if (oldAttachments?.length > 0) {
      let oldAttachmentsDetailArr = attachmentsDetailArr;

      const newAttachments = oldAttachments;
      newAttachments.splice(index, 1);

      const filterAttachmentsDetailArr = oldAttachmentsDetailArr
        .filter((obj) => obj.sr !== index + 1)
        .map((obj, index) => ({ ...obj, sr: index + 1 }));

      setLocalAttachments(newAttachments);
      AttachmentFunc(newAttachments);
      AttachmentsDetailFunc(filterAttachmentsDetailArr);

      setValue("attachmentsDetails", filterAttachmentsDetailArr);
      setValue("attachments", newAttachments);

      filterAttachmentsDetailArr.map((item, index) => {
        setValue(
          `attachmentsDetails.${index}.seedingValidityTypeValue`,
          item.seedingValidityTypeValue
        );
        setValue(`attachmentsDetails.${index}.systemName`, item.systemName);
        setValue(
          `attachmentsDetails.${index}.attachmentType`,
          item.attachmentType
        );
        setValue(
          `attachmentsDetails.${index}.masterSubAttachmentTypeId`,
          item.masterSubAttachmentTypeId
        );
        setValue(`attachmentsDetails.${index}.date`, item.date);
      });
      setDeleteReset((old) => !old);
    }
  };

  useEffect(() => {
    if (oldAttachments) {
      if (oldAttachments?.length > 0) {
        let newData = oldAttachments.map((item, index) => ({
          ...item,
          sr: index + 1,
          masterAttachmentTypeId: item?.masterAttachmentTypeId,
          attachmentId: item?.id,
        }));

        setValue("attachmentsDetails", newData);
        setLocalAttachments(newData);
      } else {
        setValue("attachmentsDetails", []);
        setLocalAttachments([]);
      }
    }
  }, [oldAttachments]);

  useEffect(() => {
    if (attachments) {
      var resultvalues = Object.values(attachments);
      // console.log({
      //   resultvalues
      // })
      // console.log("resultvalues",resultvalues)
      // console.log("localAttachments",localAttachments)
      if (resultvalues?.length > 0) {
        if (localAttachments?.length > 0) {
          let oldLocalAttachments = localAttachments;
          let oldAttachmentsDetailArr = attachmentsDetailArr;

          let newAttachmentFileArray = [
            ...oldLocalAttachments,
            ...resultvalues,
          ];
          //  console.log("newAttachmentFileArray",newAttachmentFileArray)
          setLocalAttachments(newAttachmentFileArray);
          AttachmentFunc(newAttachmentFileArray);
          setValue("attachments", newAttachmentFileArray);

          let addData = resultvalues?.map((item, i) => {
            return {
              sr: i + 1,
              name: item.name,
              seedingValidityTypeValue: "Valid",
              systemName: "",
              attachmentType: "",
              masterSubAttachmentTypeId: "",
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            };
          });

          let newAttachmentDetailsArray = [
            ...oldAttachmentsDetailArr,
            ...addData,
          ];

          let updated = newAttachmentDetailsArray.map((obj, index) => ({
            ...obj,
            sr: index + 1,
          }));

          AttachmentsDetailFunc(updated);
          setValue("attachmentsDetails", updated);
        } else {
          setLocalAttachments(resultvalues);
          //console.log(resultvalues, "resultvalues");

          // if (!isEdit) {
          AttachmentFunc(resultvalues);
          // }

          setValue("attachments", resultvalues);

          // var resultvalues = Object.values(attachments)
          let addData = resultvalues?.map((item, i) => {
            return {
              sr: i + 1,
              name: item.name,
              seedingValidityTypeValue:
                attachemntDetail[i]?.seedingValidityTypeValue || "Valid",
              systemName: attachemntDetail[i]?.systemName || "",
              masterAttachmentTypeId:
                attachemntDetail[i]?.masterAttachmentTypeId || "",
              masterSubAttachmentTypeId:
                attachemntDetail[i]?.masterSubAttachmentTypeId || "",
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            };
          });
          AttachmentsDetailFunc(addData);
          attachmentsDetailsAppend({});
          setValue("attachmentsDetails", addData);
        }
      }
    }
  }, [addFiles]);

  useEffect(() => {
    // console.log("attachmentsDetailArr",attachmentsDetailArr)
    // console.log("attachments", localAttachments);
    if (attachmentsDetailArr) {
      if (attachmentsDetailArr.length > 0) {
        AttachmentsDetailFunc(attachmentsDetailArr);
        AttachmentFunc(localAttachments);
      }
    }
  }, [resetComp]);

  const handleSaveAttachments = () => {
    if (attachments) {
      const tableData = attachments.map((item, index) => {
        return {
          sr: serialNumber++,
          name: item.name,
          seedingValidityTypeValue:
            localAttachments[index]?.selectedValidityMaster || "",
          systemName: localAttachments[index]?.systemName || "",
          attachmentType: localAttachments[index]?.selectedAttachmentType || "",
          subAttachmentType:
            localAttachments[index]?.selectedSubAttachmentType || "",
        };
      });
      attachmentData(tableData);

      // console.log("Data", tableData);
    }
  };
  // console.log("Data", localAttachments);

  const handleCheckboxChange = (event, item, index) => {
    let file = getValues("zipArray");
    if (file?.includes(index)) {
      let remove = file?.filter((i) => i !== index);
      setValue("zipArray", remove);
    } else {
      file?.push(index);
      setValue("zipArray", file);
    }
  };

  const convertBase64ToBlob = (base64Data, contentType) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters?.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters?.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  const downloadBlobAsZip = (blobData, zipFileName) => {
    const downloadUrl = URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = zipFileName;
    link.click();
    URL.revokeObjectURL(downloadUrl);
  };

  const zipFile = async (e) => {
    e.preventDefault();

    if (zipid) {
      const zipIdString = String(zipid);

      let selectedFilesToZip = [];
      let file = getValues("zipArray");
      if (file?.length > 0) {
        selectedFilesToZip = file.map((index) => ({
          fileName: oldAttachments[index]?.fileName,
          filePath: oldAttachments[index]?.filePath,
        }));
      } else {
        selectedFilesToZip = oldAttachments.map((item) => ({
          fileName: item?.fileName,
          filePath: item?.filePath,
        }));
      }

      if (selectedFilesToZip?.length > 0) {
        let req = {
          documentNo: zipIdString,
          files: selectedFilesToZip,
        };
        let result = await addRec(`/CommonOperation/CreateZipFiles`, req);
        if (result?.status === 200) {
          dispatch(messageText({ message: result?.message, msgType: 2 }));

          const zipBlob = convertBase64ToBlob(result.data, "application/zip");
          downloadBlobAsZip(zipBlob, moduleDetails);
        } else {
          dispatch(messageText({ message: result?.message, msgType: 3 }));
        }
      }
    }
  };

  useEffect(() => {
    if (message) {
      successToast(message);
      dispatch(messageText({ message: null, msgType: null }));
    }
  }, [message]);

  const callFunc = async (e, id, item) => {
    // console.log("item", item);
    e.preventDefault();
    removeOldFile(item);
    let attachmentId = oldAttachments[id].id;
    let data = await deleteRec(
      `/${moduleName}/DeleteAttachment/${item.attachmentId}`
    );
    if (data?.status === 200) {
      // getLatestAttachment(item?.id)
      dispatch(messageText({ message: data?.message, msgType: 2 }));
      handleRemoveAttachment(id);
    }
  };

  async function toDataURL(url) {
    const blob = await fetch(url).then((res) => res.blob());
    return URL.createObjectURL(blob);
  }

  const uploadedFile = async (item) => {
    const image = await fetch(item?.filePath);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);

    const link = document.createElement("a");
    link.href = imageURL;
    link.download = item?.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const newlyUploaded = (index) => {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(attachments[index]);
    link.setAttribute("download", attachments[index]?.name);
    document.body.appendChild(link);
    link.click();
  };

  const onSubmit = async (data) => {
    // console.log("🚀 ~ file: AddCops.js:151 ~ onSubmit ~ data:", data);
  };

  const [previewModal, setPreviewModal] = useState(false);
  const [filePreviewUrl, setFilePreviewUrl] = useState("");

  const openPreviewModal = (e, url) => {
    e.preventDefault();
    setFilePreviewUrl(url);
    setPreviewModal(true);
  };

  const closePreviewModal = () => {
    // setFilePreviewUrl("");
    setPreviewModal(false);
  };

  //console.log(errors)
  const table = useCallback(() => {
    return (
      <div className="comanbox_form custom_gray_bg">
        <div className="attachted ">
          <table class="table addField_table mt-3">
            <thead>
              <tr>
                {ShowZipButton && <th scope="col"></th>}
                <th scope="col">Sr</th>
                <th scope="col">Name</th>
                {GlobalAttachmentValid &&
                  <>
                    <th scope="col">Validity</th>
                    <th scope="col">System</th>
                    <th scope="col">Attachment</th>
                    <th scope="col">Sub-Attach.</th>
                  </>
                }
                <th scope="col">Date</th>
                <th scope="col">Actions</th>
                {/* <th scope="col">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {Array.from(attachmentsDetailsFields || []).map((item, index) => (
                <tr key={index}>
                  {ShowZipButton && (
                    <td>
                      {oldAttachments && item?.filePath ? (
                        <div className="form-check">
                          <input
                            type="checkbox"
                            id="select"
                            name="select"
                            onChange={(e) =>
                              handleCheckboxChange(e, item, index)
                            }
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  )}
                  <td>
                    <span> {item.sr}</span>
                  </td>
                  <td className="file_name">
                    <div key={item.name}>
                      <span>{item.name ? item.name : item.fileName}</span>
                    </div>
                  </td>

                  {/* <td>
                          <Select
                            options={seedingData?.seedingValidityTypeList?.map(
                              (item) => ({
                                value: item.id,
                                label: item.name,
                              })
                            )}
                            placeholder="Select Validity Master"
                            onChange={(selectedOption) => {
                              const newLocalAttachments = [...localAttachments];
                              newLocalAttachments[index] = {
                                ...newLocalAttachments[index],
                                selectedValidityMaster:
                                  selectedOption.label || "",
                              };
                              setLocalAttachments(newLocalAttachments);
                            }}
                            value={{
                              label:
                                localAttachments[index]?.selectedValidityMaster ||
                                "",
                            }}
                          />
                        </td> */}
                  {GlobalAttachmentValid &&
                    <>

                      <td>
                        {item?.filePath ? (
                          <div key={item.seedingValidityTypeValue}>
                            <span>{item.seedingValidityTypeValue}</span>
                          </div>
                        ) : (
                          <div class="inputcu-field">
                            <SearchableSelect
                              // placeholder="Select Validity Master"
                              required
                              placeholder={"Validity"}
                              name="seedingValidityTypeValue"
                              optionList={seedingData?.seedingValidityTypeList}
                              errors={
                                errors.hasOwnProperty("attachmentsDetails") &&
                                errors?.attachmentsDetails &&
                                errors.attachmentsDetails[index] &&
                                errors.attachmentsDetails[index]
                                  .seedingValidityTypeValue
                              }
                              control={control}
                              {...register(
                                `attachmentsDetails.${index}.seedingValidityTypeValue`,
                                {
                                  onChange: (e) => {
                                    setResetComp((old) => !old);
                                  },
                                  required: "Validity is required.",
                                }
                              )}
                            />
                          </div>
                        )}
                        {/* <input
                          type="text"
                          name="seedingValidityTypeValue"
                          id="seedingValidityTypeValue"
                          {...register(
                            `attachmentsDetails.${index}.seedingValidityTypeValue`
                            , {
                              onChange: (e) => {
                                setResetComp((old) => !old)
                              }
                            })}
                        /> */}
                      </td>
                      <td>
                        {item?.filePath ? (
                          <div key={item.systemName}>
                            <span>{item.systemName}</span>
                          </div>
                        ) : (
                          <div class="input-group">
                            <input
                              type="text"
                              name="systemName"
                              id="systemName"
                              required
                              placeholder={
                                errors.hasOwnProperty("attachmentsDetails") &&
                                  errors?.attachmentsDetails[index]?.systemName
                                  ? errors?.attachmentsDetails[index]?.systemName
                                    ?.message
                                  : "System Name"
                              }
                              className={
                                errors.hasOwnProperty("attachmentsDetails") &&
                                  errors.attachmentsDetails &&
                                  errors.attachmentsDetails[index] &&
                                  errors.attachmentsDetails[index].systemName
                                  ? "error"
                                  : ""
                              }
                              {...register(
                                `attachmentsDetails.${index}.systemName`,
                                {
                                  onChange: (e) => {
                                    setResetComp((old) => !old);
                                  },
                                  required: "System Name is required.",
                                }
                              )}
                            />
                          </div>
                        )}
                      </td>

                      <td>
                        {/* <input
                          type="text"
                          name="attachmentType"
                          id="attachmentType"
                          {...register(
                            `attachmentsDetails.${index}.attachmentType`
                            , {
                              onChange: (e) => {
                                setResetComp((old) => !old)
                              }
                            })}
                        /> */}
                        {item?.filePath ? (
                          <div key={item.masterAttachmentTypeId}>
                            <span>
                              {
                                attachmentType?.find(
                                  (obj) => obj?.id === item.masterAttachmentTypeId
                                )?.name
                              }
                            </span>
                          </div>
                        ) : (
                          <SearchableSelect
                            placeholder="Attachment"
                            name="masterAttachmentTypeId"
                            optionList={attachmentType}
                            errors={
                              errors.attachmentsDetails &&
                              errors.attachmentsDetails[index] &&
                              errors.attachmentsDetails[index]
                                .masterAttachmentTypeId
                            }
                            control={control}
                            isDisabled={item?.filePath ? true : false}
                            {...register(
                              `attachmentsDetails.${index}.masterAttachmentTypeId`,
                              {
                                onChange: (e) => {
                                  setResetComp((old) => !old);
                                  setValue(`attachmentsDetails.${index}.masterSubAttachmentTypeId`, null)
                                },
                                required: "Attachment is required.",
                              }
                            )}
                          />
                        )}
                      </td>

                      <td>
                        {/* <input
                          type="text"
                          name="subAttachmentType"
                          id="subAttachmentType"
                          {...register(
                            `attachmentsDetails.${index}.subAttachmentType`
                            , {
                              onChange: (e) => {
                                setResetComp((old) => !old)
                              }
                            })}
                        /> */}

                        {item?.filePath ? (
                          <div key={item.masterSubAttachmentTypeId}>
                            <span>
                              {
                                subAttachmentType?.find(
                                  (obj) =>
                                    obj?.id === item.masterSubAttachmentTypeId
                                )?.name
                              }
                            </span>
                          </div>
                        ) : (
                          <SearchableSelect
                            placeholder="Sub-Attach."
                            name="masterSubAttachmentTypeId"
                            optionList={subAttachmentType
                              ?.filter(
                                (obj) =>
                                  getValues(
                                    `attachmentsDetails.${index}.masterAttachmentTypeId`
                                  ) === obj?.masterAttachmentTypeId
                              )
                              .map((item) => ({
                                id: item.id,
                                name: item.name,
                              }))}
                            errors={
                              errors.attachmentsDetails &&
                              errors.attachmentsDetails[index] &&
                              errors.attachmentsDetails[index]
                                .masterSubAttachmentTypeId
                            }
                            control={control}
                            isDisabled={item?.filePath ? true : false}
                            {...register(
                              `attachmentsDetails.${index}.masterSubAttachmentTypeId`,
                              {
                                onChange: (e) => {
                                  setResetComp((old) => !old);
                                },
                                required: "SubAttach. is required.",
                              }
                            )}
                          />
                        )}
                      </td>

                      {/* <td>
                          <Select
                            options={attachmentType?.map((item) => ({
                              value: item.id,
                              label: item.attachmentType,
                            }))}
                            onChange={(selectedOption) => {
                              const newLocalAttachments = [...localAttachments];
                              newLocalAttachments[index] = {
                                ...newLocalAttachments[index],
                                selectedAttachmentType:
                                  selectedOption.label || "",
                              };
                              setLocalAttachments(newLocalAttachments);
                            }}
                            value={{
                              label:
                                localAttachments[index]?.selectedAttachmentType ||
                                "",
                            }}
                          />
                        </td> */}
                      {/* <td>
                          <Select
                            options={subAttachmentType?.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            onChange={(selectedOption) => {
                              const newLocalAttachments = [...localAttachments];
                              newLocalAttachments[index] = {
                                ...newLocalAttachments[index],
                                selectedSubAttachmentType:
                                  selectedOption.label || "",
                              };
                              setLocalAttachments(newLocalAttachments);
                            }}
                            value={{
                              label:
                                localAttachments[index]
                                  ?.selectedSubAttachmentType || "",
                            }}
                          />
                        </td> */}


                    </>
                  }
                  <td>
                    {/* {item?.filePath ? ( */}
                    <div key={item.date}>
                      <span>
                        {item?.createdDate
                          ? item?.createdDate
                          : moment(item?.date).format("DD/MM/YYYY HH:mm")}
                      </span>
                    </div>
                    {/* ) : (
                            <div class="input-group">
                            <input
                              type="text"
                              id="date"
                              name="date"
                              readOnly
                              {...register("date", {
                                matches:
                                  (/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
                                    "Date of Birth must be a valid date in the format YYYY-MM-DD"),
                              })}
                            />
                            </div>
                          )} */}

                    {/* {getcurrentDate()} */}
                  </td>
                  <td>
                    <Tooltip
                      place="bottom"
                      className="tool_tip_graph"
                      anchorId={index + "Download"}
                    />
                    <Tooltip
                      place="bottom"
                      className="tool_tip_graph"
                      anchorId={index + "Delete"}
                    />
                    {item?.filePath && (
                      <>
                        <Tooltip
                          place="bottom"
                          className="tool_tip_graph"
                          anchorId={index + "view"}
                        />
                        <span
                          id={index + "view"}
                          data-tooltip-content="View"
                          className="table_icon plue_btn"
                          onClick={(e) => openPreviewModal(e, item?.filePath)}
                        >
                          {/* <i class="fas fa-trash-alt"></i> */}
                          <i class="far fa-eye"></i>
                        </span>

                        <FilePreview
                          isOpen={previewModal}
                          onRequestClose={closePreviewModal}
                          //fileUrl={item?.filePath ? filePreviewUrl : window.URL.createObjectURL(attachments[index])}
                          fileUrl={item?.filePath ? filePreviewUrl : null}
                          newAdded={item?.filePath ? false : false}
                        />
                      </>
                    )}

                    <a
                      type="button"
                      className="delet_btn btnd_icon"
                      data-tooltip-content="Download"
                      onClick={() =>
                        item?.filePath
                          ? uploadedFile(item)
                          : newlyUploaded(index)
                      }
                      id={index + "Download"}
                    >
                      {<BiSolidDownload />}
                    </a>
                    {/* {!hideUpload && */}
                    {!item?.filePath && (
                      <a
                        type="button"
                        // disabled={item?.filePath ? true : false}
                        className="delet_btn btnd_icon"
                        data-tooltip-content="Delete"
                        onClick={(e) =>
                          item?.filePath
                            ? callFunc(e, index, item)
                            : handleRemoveAttachment(index)
                        }
                        id={index + "Delete"}
                      >
                        {<AiOutlineDelete />}
                      </a>
                    )}
                  </td>
                  {/* <td>
                          <button onClick={handleSubmit(onSubmit)}>Check</button>
                        </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div >
    );
  }, [attachmentsDetailsFields, deleteReset, previewModal, attachments]);

  return (
    <>
      <div class="col-lg-12 custom_upload">
        <div className="comanbox_form custom_gray_bg">
          <div class="export-btn buttontiel">
            <h2>Attachments</h2>
            <div class="d-flex gap-3 Attachments_flied">
              <div class="input-group mb-0">
                <div class="attech">
                  {!hideUpload && (
                    <input
                      type="file"
                      // accept=".jpg, .png, .jpeg, .svg"
                      multiple
                      id="attachments"
                      name="attachments"
                      ref={uploadInputRef}
                      style={{ color: "transparent" }}
                      {...register("attachments", {
                        onChange: (e) => {
                          setAddFiles((old) => !old);
                        },
                      })}
                      disabled={disabled}
                    />
                  )}
                </div>
              </div>
            </div>
            {ShowZipButton && oldAttachments?.length > 0 && (
              <button class="zip" onClick={(e) => zipFile(e)}>
                <img src={folder} alt="" /> <span>Zip All</span>
              </button>
            )}

            {/* <div class="buttons_containe"></div> */}
          </div>
          {attachmentsDetailsFields.length === 0 && (
            <div className="comanbox_form custom_gray_bg">
              <div className="attachted ">
                <p>No Attachment</p>
              </div>
            </div>
          )}
          {attachmentsDetailsFields &&
            attachmentsDetailsFields?.length > 0 &&
            table()}
        </div>
      </div>
    </>
  );
};
export default UploadFile;
